export const setIssloadsim = (value) => ({
  type: 'SET_ISSLOADSIM',
  payload: value,
});

export const setShouldDownloadAfterRefresh = (value) => ({
  type: 'SET_SHOULD_DOWNLOAD_AFTER_REFRESH',
  payload: value,
});

export const setDataPanelColumnSelection = (tab, selections) => ({
  type: 'SET_DATA_PANEL_COLUMN_SELECTION',
  payload: { tab, selections },
});

export const setTabFilterSelections = (tab, selections) => ({
  type: 'SET_TAB_FILTER_SELECTIONS',
  payload: { tab, selections },
});

export const setTabSortConfig = (tab, config) => ({
  type: 'SET_TAB_SORT_CONFIG',
  payload: { tab, config },
});

export const setNormalizeToggleOn = (value) => ({
  type: 'SET_NORMALIZE_TOGGLE_ON',
  payload: value,
});

export const setNormalizeToggleInitialized = (value) => ({
  type: 'SET_NORMALIZE_TOGGLE_INITIALIZED',
  payload: value,
});

export const setActiveSimulationConfig = (configKey, defaultToggleValue) => ({
  type: 'SET_ACTIVE_SIMULATION_CONFIG',
  payload: { configKey, defaultToggleValue },
});

export const resetNormalizeConfig = () => ({
  type: 'RESET_NORMALIZE_CONFIG',
});